import axios from 'axios';
import {token} from '../services/Authentication'

class CompanyService {

  static companies(term) {
        
    return axios({
      method: 'post',
      url: `${process.env.REACT_APP_URL_MEDIASIM}/empresa/todos?term=${term}`,
      headers: {        
        "content-type": "application/json",
        "authorization": token(), 
      },      
    })
    .then((res) => res, (error) => error)

  }

}


export default CompanyService;